module.exports = __webpack_public_path__ + "img/parintins-boi-garantido.22b66795.jpg";